import { Callback } from '../shared/types';

type MixinMethods = {
    capitalize(value: string): string;
    strip(value: string): string;
    truncate(value: string, maxLength?: number): string;
    toDateObj(dateString: string): Date;
    toDateStr(dateString: string, culture?: string): string;
    reverse<T>(array: T[]): T[];
    debounce(cb: Callback, delay?: number): (...args: unknown[]) => void;
};

export default {
    methods: {
        capitalize(value: string): string {
            if (!value) return '';
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        strip(value: string): string {
            if (!value) return '';
            return value.replace(/\s/g, '');
        },
        truncate(value: string, maxLength: number = 125): string {
            if (!value) return '';
            if (value.length <= maxLength) return value;

            return `${value.slice(0, maxLength).trimEnd()}...`;
        },
        toDateObj(dateString: string): Date {
            return new Date(dateString);
        },
        toDateStr(dateString: string, culture: string = 'en-GB'): string {
            const date = new Date(dateString);

            return new Intl.DateTimeFormat(culture, {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            }).format(date);
        },
        reverse<T>(array: T[]): T[] {
            return [...array].reverse();
        },
        debounce(cb: Callback, delay: number = 500): (...args: unknown[]) => void {
            let timeout: ReturnType<typeof setTimeout>;
            return (...args: any[]) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => cb(...args), delay);
            };
        }
    } as MixinMethods,
}

